import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logosidebar from "../style/imges/logosidebar.png";
import sidebarhome from "../style/icons/home.svg";
import sidebartable from '../style/icons/window-of-four-rounded-squares.svg';
import sidebarinvited from '../style/icons/multiple-users-silhouette.svg';
import sidebarwaiting from '../style/icons/clock.svg';
import sidebarblacklist from '../style/icons/list-of-three-elements-on-black-background.svg';
import sidebarcustomer from '../style/icons/customer-review.svg';
import sidebarstat from '../style/icons/statistics.svg';

const NavBar = () => {
    const [isOpen, setIsOpen] = useState(true);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
            if (window.innerWidth > 768) {
                setIsOpen(true);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    };

    const closeSidebar = () => {
        if (isMobile) {
            setIsOpen(false);
        }
    };

    return (
        <>
            {isMobile && <div className={`overlay ${isOpen ? 'visible' : ''}`} onClick={closeSidebar}></div>}
            <nav className={`sidebar-container-main flex fd-c ${isOpen ? 'open' : ''}`}>
                {isMobile && <button className="close-btn" onClick={toggleSidebar}>X</button>}
                <img className={'logo-sidebar'} src={logosidebar} alt="logo" />
                <ul className={'sidebar-container'}>
                    <li><img className={'icon-sidebar'} src={sidebarhome} alt="home" /><Link to={'/'}>דף בית</Link></li>
                    <li><img className={'icon-sidebar'} src={sidebartable} alt="table" /><Link to={'/live'}>שולחנות</Link></li>
                    <li><img className={'icon-sidebar'} src={sidebarinvited} alt="invited" /><Link to={'/invite'}>מוזמנים</Link></li>
                    <li><img className={'icon-sidebar'} src={sidebarwaiting} alt="waiting" /><Link to={'/wait'}>ממתינים</Link></li>
                    <li><img className={'icon-sidebar'} src={sidebarblacklist} alt="blacklist" /><Link to={'/blacklist'}>רשימת חסומים</Link></li>
                    <li><img className={'icon-sidebar'} src={sidebarcustomer} alt="customer" /><Link to={'/clients'}>לקוחות</Link></li>
                    <li><img className={'icon-sidebar'} src={sidebarstat} alt="stats" /><Link to={'/stats'}>סטטיסטיקות</Link></li>
                </ul>
            </nav>
            {isMobile && <button className="hamburger-btn" onClick={toggleSidebar}>
                <span className="hamburger-icon"></span>
            </button>}
        </>
    );
};

export default NavBar;